export const CLIENT_PROPOSAL_PATH = 'client-proposal' as const;
